<div class="tag-details-view-container" *ngIf="tagObject" fxLayout="column" fxLayoutGap="15px" >
  <div fxLayout="row" fxLayoutGap="15px">
    <button [disabled]="!(userPermissions | async).asf_360.write " (click)="modify()" mat-stroked-button color="primary"><mat-icon>create</mat-icon> <span> Edytuj</span></button>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" fxFlex="100" fxLayout.lt-lg="column">
    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px">
      <mat-card>

        <div fxLayout="row">
          <h3>Dane</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
            <app-detail  header="Nazwa tagu" [value]="tagObject.name"></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
              <app-detail  header=" Typ tagu" [value]="tagObject.type?.name"></app-detail>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
              <app-detail-bool header="Aktywny " [value]="tagObject.active"></app-detail-bool>
          </div>
        </div>
      </mat-card>

      <mat-card *ngIf="tagObject.type.key===POST_TAG_TYPE_INSURANCE_COMPANY || tagObject.type.key===POST_TAG_TYPE_DEPARTMENT_TYPE">

        <div fxLayout="row" fxLayoutGap="15px" fxLayoutAlign="space-around center" >
          <div fxFlex="100" >
            <h3>Logo</h3>
          </div>

        </div>
        <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="space-around center">

        </div>

        <div fxLayout="row" fxLayoutGap="25px" fxLayoutAlign="space-around center">

          <div fxFlex="50" *ngIf="tagObject.content" >
            <button  [disabled]="!(userPermissions | async).asf_360.write" (click)="setImage()" mat-stroked-button color="primary"><mat-icon>file_upload</mat-icon> <span> Zmień Logo</span></button>
          </div>
          <div fxFlex="50"   *ngIf="!tagObject.content">
            <button [disabled]="!(userPermissions | async).asf_360.write" (click)="setImage()" mat-stroked-button color="primary"><mat-icon>file_upload</mat-icon> <span> Dodaj Logo</span></button>
          </div>

          <input #imageSelect type="file" style="display: none" [formControl]="imageSelectControl"
                 accept=".jpg,.gif,.png,.jpeg"/>

          <div fxFlex="50">
            <img class="avatar circular-image"   *ngIf="tagObject.content"  id="imageToCrop"  [src]="tagObject.content" alt="Logo"/>
          </div>
        </div>


      </mat-card>



    </div>

    <div fxLayout="column" fxFlex="50" fxFlex.lt-md="100" fxLayoutGap="15px" >

      <mat-card *ngIf="tagObject.type.key === POST_TAG_TYPE_INSURANCE_COMPANY ">

        <div fxLayout="row">
          <h3>Grafiki</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <ng-container *ngFor="let graphics of tagObject.graphics; let i = index">
              <div fxLayout="row" fxLayoutGap="15px"  fxLayoutAlign="space-around center">
                <span fxFlex="5">{{i+1}}.</span>
                <div  fxFlex="40" >
                 <img *ngIf="graphics.graphicsLocation" class="avatar-360" [src]="'rest/crm/asf360/tag/graphics/' + graphics.graphicsUuid +'/image/'+ graphics.graphicsFilename " alt="{{graphics.graphicsFilename}}" />
                  <h4 *ngIf="!graphics.graphicsLocation"> Brak grafiki.</h4>
                </div>
                <app-detail fxFlex="40" header="Typ postu">{{graphics.graphicsType}}</app-detail>
              </div>
            </ng-container>
          </div>
        </div>

      </mat-card>

      <mat-card *ngIf=" tagObject.type.key === POST_TAG_TYPE_POST_TYPE">

        <div fxLayout="row">
          <h3>Grafika</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <ng-container *ngFor="let graphics of tagObject.graphics; let i = index">
              <div fxLayout="row" fxLayoutGap="15px"  fxLayoutAlign="space-around center">
                  <img *ngIf="graphics.graphicsLocation" class="avatar-360" [src]="'rest/crm/asf360/tag/graphics/' + graphics.graphicsUuid +'/image/'+ graphics.graphicsFilename " alt="{{graphics.graphicsFilename}}" />
                  <h4 *ngIf="!graphics.graphicsLocation"> Brak grafiki.</h4>
              </div>
            </ng-container>
          </div>
        </div>

      </mat-card>

      <mat-card *ngIf="tagObject.type.key===POST_TAG_TYPE_DEPARTMENT_TYPE">

        <div fxLayout="row">
          <h3>Użytkownicy</h3>
        </div>

        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100">
            <ng-container *ngFor="let users of tagObject.users; let i = index">
              <div fxLayout="row" >
                <div fxLayout="column" fxFlex="5"   fxLayoutAlign="center center"  >
                    <span  fxLayoutAlign="center center"  fxFlex="100">{{i+1}}.</span>
                </div>
                <div fxLayout="column"  fxFlex="80" >
                  <div fxLayout="row"  fxFlex="100"  fxLayoutGap="15px"  fxLayoutAlign="space-around center" >
                    <app-detail fxFlex="47" header="Imie i nazwisko">{{users.usersName}}</app-detail>
                    <app-detail fxFlex="47" header="Stanowisko">{{users.usersPosition}}</app-detail>

                  </div>
                  <div fxLayout="row"  fxFlex="100"  fxLayoutGap="15px" fxLayoutAlign="space-around center" >
                    <app-detail fxFlex="47" header="Numer telefonu">{{users.usersPhone}}</app-detail>
                    <app-detail fxFlex="47" header="Email">{{users.usersEmail}}</app-detail>
                  </div>
               </div>
                <div fxLayout="column"  fxFlex="15" >
                  <div fxLayout="row"  fxFlex="100"    fxLayoutGap="15px"  fxLayoutAlign="space-around center" >
                    <img class="circular-image avatar" src="/rest/sso/api/user/{{users.usersUuid}}/avatar" alt="Brak zdjęcia" onerror="this.style.display='none'; this.insertAdjacentHTML('afterend', 'Brak zdjęcia')" />
                  </div>
                </div>
              </div>

            </ng-container>
          </div>
        </div>

      </mat-card>

      <mat-card *ngIf="tagObject.type.key===POST_TAG_TYPE_DEPARTMENT_TYPE">

        <div fxLayout="row">
          <h3>Nagłówek</h3>
        </div>


        <div fxLayout="row" fxLayoutGap="15px">
          <div fxFlex="100" >
            <app-detail  header=" Nagłówek" [value]="tagObject.header"></app-detail>
          </div>
        </div>

      </mat-card>


    </div>
  </div>
</div>
